"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Button } from "~~/app/common/tailwind/Button";

export const HomepageBanner = () => {
  const t = useTranslations("Homepage");
  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="flex flex-col lg:flex-row w-full max-w-[1900px] px-6 md:px-12 lg:px-24 py-12 md:py-16 lg:py-32 md:gap-8 lg:gap-auto">
        <div className="flex-1 flex justify-center items-center pt-8 px-6 md:p-8 lg:p-16">
          <div className="relative w-full">
            <Image
              src="/home_assets/shutdown/classic.svg"
              alt="Pirate Nation Classic"
              width="500"
              height="500"
            />
          </div>
        </div>

        {/* Right Section - Content Area */}
        <div className="flex-1 flex flex-col justify-center p-6 md:p-8 lg:p-16 text-center lg:text-left">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-8 md:mb-10">
            {t("Banner.title")}
          </h2>

          <p className="text-lg md:text-xl lg:text-2xl text-white mb-12 md:mb-16 leading-relaxed">
            {t.rich("Banner.description", {
              bold: (chunks) => (
                <span className="text-basicsgold-500 font-semibold">
                  {chunks}
                </span>
              ),
            })}
          </p>

          <div>
            <Button
              href="https://arcade.piratenation.game"
              variant="3d"
              color="primary"
              analyticsId={`click home hero cta`}
              analyticsProps={{
                action: "play",
              }}
              className="py-10 md:py-12 lg:py-16 text-xl md:text-2xl w-full md:w-auto"
            >
              {t("Banner.play_btn")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
